export class Authserverconstants {
    //Claims Values
    public static Claim_Role_Admin_Value = "gpdiaryadmin";
    public static Claim_User_Type_Member_Value = "Member";
    public static Claim_User_Type_Staff_Value = "Staff";
    public static Claim_User_Profile_Status_Value = "Current";

    public static Admin_Features_Url = 'admin';
    public static Members_Features_Url = 'user';
    public static Claim_Role_Test_Member_Value = 'PilotTestMemberGroup'
}
